var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({attrs:{"color":_vm.stageStateIcon.color}},on),[_vm._v(_vm._s(_vm.stageStateIcon.icon)+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.stageStateIcon.toolTip)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }